import { createServerFn } from '@tanstack/react-start'
import { getRequestHeaders } from '@tanstack/react-start/server'
import { auth } from './auth'
import { devAuthEnabled, devSession } from './dev-auth'

export const getSession = createServerFn({ method: 'GET' }).handler(async () => {
  // Dev bypass: hand back a stub operator so /admin does not bounce to /login.
  if (devAuthEnabled()) return devSession()
  const headers = getRequestHeaders()
  const session = await auth.api.getSession({ headers })
  return session
})

export const ensureSession = createServerFn({ method: 'GET' }).handler(async () => {
  if (devAuthEnabled()) return devSession()
  const headers = getRequestHeaders()
  const session = await auth.api.getSession({ headers })
  if (!session) {
    throw new Error('Not authenticated')
  }
  return session
})
